<template>
  <v-row row wrap>

    <v-col cols="12">
      <v-row justify="end" class="px-4">
        <survey-view-configs-modal
          v-model="surveyViewConfigModal"
        ></survey-view-configs-modal>
        <v-btn outlined @click="openSurveyViewConfig">
          <v-icon left>mdi-cog</v-icon>
          Configuración de vistas
        </v-btn>
      </v-row>
    </v-col>

    <v-col cols="12">

      <v-data-table
          class="mt-3"
          :headers="headers"
          :items="items"
          :search="search"
          :single-expand="false"
          :server-items-length="totalItems"
          :loading="loading"
          :page.sync="pageNumber"
          :items-per-page.sync="itemsPerPage"
          :sort-by.sync="orderBy"
          :sort-desc.sync="orderDesc"
          :footer-props="{ itemsPerPageOptions: [5, 10, 25, 50] }"
          @update:page="fetch"
          @update:sort-by="fetch"
          @update:sort-desc="fetch"
          @update:items-per-page="fetch"
      >

        <template v-slot:item.active="{item}">
          <v-icon v-if="item.active" color="green">done</v-icon>
          <v-icon v-else color="red">clear</v-icon>
        </template>

        <template v-slot:item.image="{item}">
          <v-avatar tile>
            <v-img :src="item.image"/>
          </v-avatar>
        </template>


        <template slot="no-data">
          <div class="text-xs-center" v-t="'common.noData'"></div>
        </template>

        <template slot="loading">
          <div class="text-xs-center" v-t="'common.loading'"></div>
        </template>

        <template v-slot:item.action="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <show-button @click="$emit('show', item)" v-bind="attrs" v-on="on"/>
            </template>
            <span>{{ $t('common.show') }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <edit-button v-if="$store.getters.hasPermission('SURVEYS_UPDATE')" @click="$emit('update', item)" v-bind="attrs" v-on="on"/>
            </template>
            <span>{{ $t('base.edit') }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <delete-button v-if="$store.getters.hasPermission('SURVEYS_DELETE')" @click="$emit('delete', item)" v-bind="attrs" v-on="on"/>
            </template>
            <span>{{ $t('common.delete') }}</span>
          </v-tooltip>
        </template>

      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import SurveysProvider from "../../../../providers/SurveysProvider";
import SurveyViewConfigsModal from './SurveyViewConfigsModal.vue'

import {DeleteButton, EditButton, ShowButton} from "@dracul/common-frontend"


export default {
  name: "SurveysList",
  components: {DeleteButton, EditButton, ShowButton, SurveyViewConfigsModal},

  data() {
    return {
      items: [],
      totalItems: null,
      loading: false,
      orderBy: null,
      orderDesc: false,
      itemsPerPage: 5,
      pageNumber: 1,
      search: '',
      filters: [
        /*{
            field: '',
            operator: 'eq', //(eq|contain|regex|gt|lt|lte|gte)
            value: ''
        }*/
      ],
      surveyViewConfigModal: false
    }
  },
  computed: {
    headers() {
      return [
        //Entity Headers
        {text: this.$t('delivery.surveys.labels.name'), value: 'name'},
        {text: this.$t('delivery.surveys.labels.description'), value: 'description'},
        //Actions
        {text: this.$t('common.actions'), value: 'action', sortable: false, align: 'center'},
      ]
    },
    getOrderBy() {
      return (Array.isArray(this.orderBy)) ? this.orderBy[0] : this.orderBy
    },
    getOrderDesc() {
      return (Array.isArray(this.orderDesc)) ? this.orderDesc[0] : this.orderDesc
    }
  },
  created() {
    this.fetch()
  },
  methods: {
    openSurveyViewConfig() {
      this.surveyViewConfigModal = true
    },
    performSearch() {
      this.pageNumber = 1
      this.fetch()
    },
    fetch() {
      this.loading = true
      SurveysProvider.paginateSurvey(
          this.pageNumber,
          this.itemsPerPage,
          this.search,
          this.filters,
          this.getOrderBy,
          this.getOrderDesc
      ).then(r => {
        this.items = r.data.paginateSurvey.items
        this.totalItems = r.data.paginateSurvey.totalItems
      }).catch(err => {
        console.error(err)
      }).finally(() => this.loading = false)
    }
  }

}
</script>


